(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Bundle = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initArticleFeedback = void 0;
var axios_1 = __importDefault(require("axios"));
var ROOT_SELECTOR = '[data-article-feedback]';
function initArticleFeedback() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initArticleFeedbackRoot);
}
exports.initArticleFeedback = initArticleFeedback;
function initArticleFeedbackRoot(feedbackSection) {
    var _this = this;
    var _a;
    var documentId = feedbackSection.dataset.documentId;
    var submittedMessage = (_a = feedbackSection.dataset.submittedMessage) !== null && _a !== void 0 ? _a : 'Thanks for your feedback.';
    var title = feedbackSection.querySelector('.article-feedback__title');
    var status = feedbackSection.querySelector('[data-article-feedback-status]');
    var buttons = feedbackSection.querySelectorAll('[data-article-feedback-rating]');
    if (!documentId || buttons.length === 0) {
        return;
    }
    var isSubmitting = false;
    var setLoadingState = function (activeButton) {
        buttons.forEach(function (button) {
            button.disabled = true;
            if (button === activeButton) {
                button.classList.add('article-feedback__button--loading');
                button.setAttribute('aria-busy', 'true');
            }
        });
    };
    var clearLoadingState = function () {
        buttons.forEach(function (button) {
            button.classList.remove('article-feedback__button--loading');
            button.removeAttribute('aria-busy');
        });
    };
    var setSubmittedState = function (message) {
        clearLoadingState();
        buttons.forEach(function (button) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
        });
        if (title) {
            title.textContent = message;
        }
        if (status) {
            status.hidden = true;
        }
    };
    var setErrorState = function (message) {
        if (!status) {
            return;
        }
        status.textContent = message;
        status.hidden = false;
    };
    var submitFeedback = function (rating, activeButton) { return __awaiter(_this, void 0, void 0, function () {
        var payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        return [2];
                    }
                    isSubmitting = true;
                    setLoadingState(activeButton);
                    if (status) {
                        status.hidden = true;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload = {
                        documentId: documentId,
                        rating: rating,
                    };
                    return [4, axios_1.default.post('/api/articles/feedback', payload)];
                case 2:
                    _a.sent();
                    setSubmittedState(submittedMessage);
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Failed to submit article feedback:', error_1);
                    clearLoadingState();
                    buttons.forEach(function (button) {
                        button.disabled = false;
                        button.removeAttribute('aria-disabled');
                    });
                    setErrorState('Something went wrong. Please try again.');
                    return [3, 5];
                case 4:
                    isSubmitting = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            var rating = button.dataset.articleFeedbackRating;
            if (rating === 'positive' || rating === 'negative') {
                void submitFeedback(rating, button);
            }
        });
    });
}
},{"axios":18}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAssistanceComponent = void 0;
var ROOT_SELECTOR = '[data-assistance-component]';
var TAB_SELECTOR = '[data-assistance-component-tab]';
var PANEL_SELECTOR = '[data-assistance-component-panel]';
var HEADER_SELECTOR = '.assistance-component__header';
var LAYOUT_SELECTOR = '.assistance-component__layout';
var DESKTOP_MQ = '(min-width: 1150px)';
var STUCK_CLASS = 'assistance-component__header--is-stuck';
var PINNED_CLASS = 'assistance-component__header--is-pinned-bottom';
function initAssistanceComponent() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initAssistanceComponentRoot);
}
exports.initAssistanceComponent = initAssistanceComponent;
function initAssistanceComponentRoot(root) {
    initAssistanceComponentTabs(root);
    initAssistanceComponentStickyHeader(root);
}
function initAssistanceComponentTabs(root) {
    var tabs = root.querySelectorAll(TAB_SELECTOR);
    var panels = root.querySelectorAll(PANEL_SELECTOR);
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            var id = tab.getAttribute('data-assistance-component-tab');
            if (!id)
                return;
            tabs.forEach(function (item) {
                var isActive = item === tab;
                item.classList.toggle('assistance-component__toggle-btn--active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            panels.forEach(function (panel) {
                var isActive = panel.getAttribute('data-assistance-component-panel') === id;
                panel.classList.toggle('assistance-component__panel--hidden', !isActive);
            });
            root.dispatchEvent(new CustomEvent('assistance-component:update'));
        });
    });
}
function initAssistanceComponentStickyHeader(root) {
    var header = root.querySelector(HEADER_SELECTOR);
    var layout = root.querySelector(LAYOUT_SELECTOR);
    if (!header || !layout)
        return;
    var mq = window.matchMedia(DESKTOP_MQ);
    var raf = 0;
    var columnLeft = 0;
    var columnWidth = 0;
    var getStickyTop = function () {
        var siteHeader = document.querySelector('[data-site-header]');
        return siteHeader ? siteHeader.getBoundingClientRect().height + 16 : 32;
    };
    var resetHeader = function () {
        header.classList.remove(STUCK_CLASS, PINNED_CLASS);
        header.style.removeProperty('position');
        header.style.removeProperty('top');
        header.style.removeProperty('left');
        header.style.removeProperty('width');
        header.style.removeProperty('z-index');
    };
    var measureColumn = function () {
        var wasStuck = header.classList.contains(STUCK_CLASS);
        if (wasStuck) {
            resetHeader();
        }
        var rect = header.getBoundingClientRect();
        columnLeft = rect.left;
        columnWidth = rect.width;
    };
    var updateStickyHeader = function () {
        if (!mq.matches) {
            resetHeader();
            return;
        }
        var stickyTop = getStickyTop();
        var layoutRect = layout.getBoundingClientRect();
        var headerHeight = header.offsetHeight;
        if (layoutRect.top >= stickyTop) {
            resetHeader();
            measureColumn();
            return;
        }
        if (layoutRect.bottom <= headerHeight + stickyTop) {
            resetHeader();
            header.classList.add(PINNED_CLASS);
            return;
        }
        if (!columnWidth) {
            measureColumn();
        }
        header.classList.remove(PINNED_CLASS);
        header.classList.add(STUCK_CLASS);
        header.style.position = 'fixed';
        header.style.top = stickyTop + "px";
        header.style.left = columnLeft + "px";
        header.style.width = columnWidth + "px";
        header.style.zIndex = '2';
    };
    var scheduleStickyUpdate = function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateStickyHeader);
    };
    mq.addEventListener('change', scheduleStickyUpdate);
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', function () {
        measureColumn();
        scheduleStickyUpdate();
    });
    root.addEventListener('assistance-component:update', function () {
        measureColumn();
        scheduleStickyUpdate();
    });
    measureColumn();
    scheduleStickyUpdate();
}
},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCardGrid = void 0;
var equalize_heights_1 = require("../../utils/equalize-heights");
var ROOT_SELECTOR = '.card-grid';
var GRID_SELECTOR = '.card-grid__grid';
var CARD_SELECTOR = '.card-grid__card';
function initCardGrid() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initCardGridRoot);
}
exports.initCardGrid = initCardGrid;
function initCardGridRoot(root) {
    var grid = root.querySelector(GRID_SELECTOR);
    if (!grid)
        return;
    function equalizeCards() {
        equalize_heights_1.equalizeHeights(root.querySelectorAll(CARD_SELECTOR));
    }
    equalizeCards();
    window.addEventListener('resize', equalizeCards);
    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(function () { return equalizeCards(); });
        resizeObserver.observe(grid);
    }
    root.querySelectorAll(CARD_SELECTOR + " img").forEach(function (img) {
        if (!img.complete) {
            img.addEventListener('load', function () { return equalizeCards(); }, { once: true });
        }
    });
}
},{"../../utils/equalize-heights":16}],4:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCarousel = void 0;
var carousel_swipe_1 = require("../../utils/carousel-swipe");
var equalize_heights_1 = require("../../utils/equalize-heights");
var ROOT_SELECTOR = '[data-carousel]';
var VIEWPORT_SELECTOR = '[data-carousel-viewport]';
var TRACK_SELECTOR = '[data-carousel-track]';
var SLIDE_SELECTOR = '[data-carousel-slide]';
var PROGRESS_SELECTOR = '[data-carousel-progress]';
var PREV_SELECTOR = '[data-carousel-prev]';
var NEXT_SELECTOR = '[data-carousel-next]';
var BLADE_SELECTOR = '[data-carousel-blade]';
var BLADE_OPEN_SELECTOR = '[data-carousel-blade-open]';
var BLADE_CLOSE_SELECTOR = '[data-carousel-blade-close]';
var BLADE_VIEW_SELECTOR = '[data-carousel-blade-view]';
var HEADER_SELECTOR = '.carousel__card-header';
function getVisibleCount(viewport, slideWidth, gap) {
    if (!slideWidth)
        return 1;
    return Math.max(1, Math.floor((viewport.offsetWidth + gap) / (slideWidth + gap)));
}
function initCarousel() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initCarouselRoot);
}
exports.initCarousel = initCarousel;
function initCarouselRoot(root) {
    initCarouselTrack(root);
    initCarouselBlade(root);
}
function initCarouselBlade(root) {
    var blade = root.querySelector(BLADE_SELECTOR);
    if (!blade)
        return;
    var views = blade.querySelectorAll(BLADE_VIEW_SELECTOR);
    var openButtons = root.querySelectorAll(BLADE_OPEN_SELECTOR);
    var closeButtons = blade.querySelectorAll(BLADE_CLOSE_SELECTOR);
    function setBladeOpen(isOpen, viewIndex) {
        document.body.classList.toggle('carousel-blade-open', isOpen);
        blade.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        if (isOpen && viewIndex !== undefined) {
            views.forEach(function (view) {
                var isActive = view.getAttribute('data-carousel-blade-view') === viewIndex;
                view.classList.toggle('carousel__blade-view--hidden', !isActive);
            });
        }
    }
    openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var index = button.getAttribute('data-carousel-blade-open');
            if (index === null)
                return;
            setBladeOpen(true, index);
        });
    });
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () { return setBladeOpen(false); });
    });
    window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('carousel-blade-open')) {
            setBladeOpen(false);
        }
    });
}
function initCarouselTrack(root) {
    var viewport = root.querySelector(VIEWPORT_SELECTOR);
    var track = root.querySelector(TRACK_SELECTOR);
    var slides = root.querySelectorAll(SLIDE_SELECTOR);
    var progress = root.querySelector(PROGRESS_SELECTOR);
    var prev = root.querySelector(PREV_SELECTOR);
    var next = root.querySelector(NEXT_SELECTOR);
    if (!viewport || !track || !slides.length)
        return;
    var index = 0;
    function equalizeCardHeaders() {
        equalize_heights_1.equalizeHeights(root.querySelectorAll(HEADER_SELECTOR));
    }
    function getBaseOffset() {
        var slide = slides[0];
        var gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return index * (slide.offsetWidth + gap);
    }
    function applyTrackOffset(offsetPx) {
        track.style.transform = "translateX(-" + offsetPx + "px)";
    }
    function update() {
        var slide = slides[0];
        var gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var slideWidth = slide.offsetWidth;
        var visible = getVisibleCount(viewport, slideWidth, gap);
        var maxIndex = Math.max(0, slides.length - visible);
        index = Math.min(index, maxIndex);
        applyTrackOffset(getBaseOffset());
        if (progress) {
            var progressEnd = Math.min(slides.length, index + visible);
            progress.style.width = (progressEnd / slides.length) * 100 + "%";
        }
        if (prev)
            prev.disabled = index <= 0;
        if (next)
            next.disabled = index >= maxIndex;
        equalizeCardHeaders();
    }
    function goTo(newIndex) {
        var slide = slides[0];
        var gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var visible = getVisibleCount(viewport, slide.offsetWidth, gap);
        var maxIndex = Math.max(0, slides.length - visible);
        index = Math.max(0, Math.min(maxIndex, newIndex));
        update();
    }
    prev === null || prev === void 0 ? void 0 : prev.addEventListener('click', function () { return goTo(index - 1); });
    next === null || next === void 0 ? void 0 : next.addEventListener('click', function () { return goTo(index + 1); });
    window.addEventListener('resize', update);
    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(function () { return equalizeCardHeaders(); });
        resizeObserver.observe(track);
    }
    slides.forEach(function (slide) {
        slide.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
                img.addEventListener('load', function () { return equalizeCardHeaders(); }, { once: true });
            }
        });
    });
    carousel_swipe_1.initCarouselSwipe({
        viewport: viewport,
        getBaseOffset: getBaseOffset,
        onDrag: applyTrackOffset,
        onCommit: function (direction) {
            if (direction === 0) {
                update();
                return;
            }
            goTo(index + direction);
        },
    });
    update();
}
},{"../../utils/carousel-swipe":14,"../../utils/equalize-heights":16}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHeaderWithSearch = void 0;
var article_search_autocomplete_1 = require("../../utils/article-search-autocomplete");
var suggestions_scrollbar_1 = require("../../utils/suggestions-scrollbar");
var ROOT_SELECTOR = '.header-with-search';
var INPUT_SELECTOR = '.header-with-search__input';
var SUBMIT_SELECTOR = '.header-with-search__submit';
var SUGGESTIONS_SELECTOR = '.header-with-search__suggestions';
function initHeaderWithSearch() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initHeaderWithSearchRoot);
    suggestions_scrollbar_1.initAllSuggestionsScrollbars();
}
exports.initHeaderWithSearch = initHeaderWithSearch;
function getSubmitUrl(root) {
    if (root.dataset.searchLink) {
        return new URL(root.dataset.searchLink, window.location.origin);
    }
    if (root.classList.contains('header-with-search--search-results')) {
        return new URL(window.location.href);
    }
    return null;
}
function navigateToSearch(root, query) {
    var trimmedQuery = query.trim();
    if (!trimmedQuery)
        return;
    var submitUrl = getSubmitUrl(root);
    if (!submitUrl)
        return;
    submitUrl.searchParams.set('q', trimmedQuery);
    window.location.href = submitUrl.toString();
}
var SUGGESTIONS_ID = 'header-with-search-suggestions';
function initSearchFieldAccessibility(searchInput, submitButton, suggestionsList) {
    if (suggestionsList && !suggestionsList.id) {
        suggestionsList.id = SUGGESTIONS_ID;
    }
    searchInput.setAttribute('role', 'combobox');
    searchInput.setAttribute('aria-autocomplete', 'list');
    if (!searchInput.getAttribute('aria-expanded')) {
        searchInput.setAttribute('aria-expanded', 'false');
    }
    if (suggestionsList === null || suggestionsList === void 0 ? void 0 : suggestionsList.id) {
        searchInput.setAttribute('aria-controls', suggestionsList.id);
    }
    submitButton === null || submitButton === void 0 ? void 0 : submitButton.setAttribute('role', 'button');
}
function initHeaderWithSearchRoot(root) {
    var searchInput = root.querySelector(INPUT_SELECTOR);
    var submitButton = root.querySelector(SUBMIT_SELECTOR);
    var suggestionsList = root.querySelector(SUGGESTIONS_SELECTOR);
    if (!searchInput)
        return;
    initSearchFieldAccessibility(searchInput, submitButton, suggestionsList);
    if (suggestionsList && root.dataset.searchStaticSuggestions !== 'true') {
        article_search_autocomplete_1.initArticleSearchAutocomplete({
            root: root,
            input: searchInput,
            suggestionsList: suggestionsList,
        });
    }
    var handleSubmit = function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        navigateToSearch(root, searchInput.value);
    };
    searchInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter')
            return;
        if (searchInput.getAttribute('aria-expanded') === 'true' && searchInput.getAttribute('aria-activedescendant')) {
            return;
        }
        event.preventDefault();
        handleSubmit();
    });
    submitButton === null || submitButton === void 0 ? void 0 : submitButton.addEventListener('click', handleSubmit);
}
},{"../../utils/article-search-autocomplete":13,"../../utils/suggestions-scrollbar":17}],6:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSiteHeader = void 0;
var ROOT_SELECTOR = '.site-header-root';
var HEADER_SELECTOR = '[data-site-header]';
var DRAWER_SELECTOR = '[data-site-header-drawer]';
var TOGGLE_SELECTOR = '[data-site-header-toggle]';
var SCROLL_THRESHOLD = 16;
function initSiteHeader() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSiteHeaderRoot);
}
exports.initSiteHeader = initSiteHeader;
function initSiteHeaderRoot(root) {
    var header = root.querySelector(HEADER_SELECTOR);
    var drawer = root.querySelector(DRAWER_SELECTOR);
    var toggles = root.querySelectorAll(TOGGLE_SELECTOR);
    if (!header || !drawer || !toggles.length)
        return;
    var menuScrollY = 0;
    function setScrolled() {
        if (document.body.classList.contains('site-header-menu-open'))
            return;
        header.classList.toggle('site-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
    }
    function setMenuOpen(isOpen) {
        var wasOpen = document.body.classList.contains('site-header-menu-open');
        if (isOpen && !wasOpen) {
            menuScrollY = window.scrollY;
            document.body.style.top = "-" + menuScrollY + "px";
        }
        else if (!isOpen && wasOpen) {
            document.body.style.top = '';
            window.scrollTo(0, menuScrollY);
        }
        document.documentElement.classList.toggle('site-header-menu-open', isOpen);
        document.body.classList.toggle('site-header-menu-open', isOpen);
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    }
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            setMenuOpen(!document.body.classList.contains('site-header-menu-open'));
        });
    });
    drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { return setMenuOpen(false); });
    });
    window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            setMenuOpen(false);
        }
    });
}
},{}],7:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initProductTiers = void 0;
var carousel_swipe_1 = require("../../utils/carousel-swipe");
var equalize_heights_1 = require("../../utils/equalize-heights");
var ROOT_SELECTOR = '[data-product-tiers]';
var TAB_SELECTOR = '[data-product-tiers-tab]';
var PANEL_SELECTOR = '[data-product-tiers-panel]';
var VIEWPORT_SELECTOR = '[data-product-tiers-carousel]';
var TRACK_SELECTOR = '[data-product-tiers-track]';
var SLIDE_SELECTOR = '[data-product-tiers-slide]';
var PROGRESS_SELECTOR = '[data-product-tiers-progress]';
var PREV_SELECTOR = '[data-product-tiers-prev]';
var NEXT_SELECTOR = '[data-product-tiers-next]';
var NAV_SELECTOR = '[data-product-tiers-nav]';
var BLADE_SELECTOR = '[data-product-tiers-blade]';
var BLADE_OPEN_SELECTOR = '[data-product-tiers-blade-open]';
var BLADE_CLOSE_SELECTOR = '[data-product-tiers-blade-close]';
var BLADE_VIEW_SELECTOR = '[data-product-tiers-blade-view]';
var HEADER_SELECTOR = '.product-tiers__card-header';
var GRID_MQ = '(min-width: 1500px)';
function getVisibleCount(viewport, slideWidth, gap) {
    if (!slideWidth)
        return 1;
    return Math.max(1, Math.floor((viewport.offsetWidth + gap) / (slideWidth + gap)));
}
function initProductTiers() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initProductTiersRoot);
}
exports.initProductTiers = initProductTiers;
function initProductTiersRoot(root) {
    var tabs = root.querySelectorAll(TAB_SELECTOR);
    var panels = root.querySelectorAll(PANEL_SELECTOR);
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            var id = tab.getAttribute('data-product-tiers-tab');
            if (!id)
                return;
            tabs.forEach(function (item) {
                var isActive = item === tab;
                item.classList.toggle('product-tiers__toggle-btn--active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            panels.forEach(function (panel) {
                var isActive = panel.getAttribute('data-product-tiers-panel') === id;
                panel.classList.toggle('product-tiers__panel--hidden', !isActive);
                if (isActive) {
                    equalizeCardHeaders(panel);
                }
            });
        });
    });
    panels.forEach(function (panel) { return initProductTiersCarousel(panel); });
    initProductTiersBlade(root);
}
function initProductTiersBlade(root) {
    var blade = root.querySelector(BLADE_SELECTOR);
    if (!blade)
        return;
    var views = blade.querySelectorAll(BLADE_VIEW_SELECTOR);
    var openButtons = root.querySelectorAll(BLADE_OPEN_SELECTOR);
    var closeButtons = blade.querySelectorAll(BLADE_CLOSE_SELECTOR);
    function setBladeOpen(isOpen, viewIndex) {
        document.body.classList.toggle('product-tiers-blade-open', isOpen);
        blade.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        if (isOpen && viewIndex !== undefined) {
            views.forEach(function (view) {
                var isActive = view.getAttribute('data-product-tiers-blade-view') === viewIndex;
                view.classList.toggle('product-tiers__blade-view--hidden', !isActive);
            });
        }
    }
    openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var index = button.getAttribute('data-product-tiers-blade-open');
            if (index === null)
                return;
            setBladeOpen(true, index);
        });
    });
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () { return setBladeOpen(false); });
    });
    window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('product-tiers-blade-open')) {
            setBladeOpen(false);
        }
    });
}
function equalizeCardHeaders(panel) {
    if (panel.classList.contains('product-tiers__panel--hidden'))
        return;
    equalize_heights_1.equalizeHeights(panel.querySelectorAll(HEADER_SELECTOR));
}
function initProductTiersCarousel(panel) {
    var viewport = panel.querySelector(VIEWPORT_SELECTOR);
    var track = panel.querySelector(TRACK_SELECTOR);
    var slides = panel.querySelectorAll(SLIDE_SELECTOR);
    var progress = panel.querySelector(PROGRESS_SELECTOR);
    var prev = panel.querySelector(PREV_SELECTOR);
    var next = panel.querySelector(NEXT_SELECTOR);
    var nav = panel.querySelector(NAV_SELECTOR);
    if (!viewport || !track || !slides.length)
        return;
    var index = 0;
    function isCarouselMode() {
        return !window.matchMedia(GRID_MQ).matches;
    }
    function getCarouselMetrics() {
        var slide = slides[0];
        var gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var slideWidth = slide.offsetWidth;
        var visible = getVisibleCount(viewport, slideWidth, gap);
        var maxIndex = Math.max(0, slides.length - visible);
        return { gap: gap, slideWidth: slideWidth, visible: visible, maxIndex: maxIndex };
    }
    function getBaseOffset() {
        var _a = getCarouselMetrics(), gap = _a.gap, slideWidth = _a.slideWidth;
        return index * (slideWidth + gap);
    }
    function applyTrackOffset(offsetPx) {
        track.style.transform = "translateX(-" + offsetPx + "px)";
    }
    function update() {
        if (isCarouselMode()) {
            var _a = getCarouselMetrics(), gap = _a.gap, slideWidth = _a.slideWidth, visible = _a.visible, maxIndex = _a.maxIndex;
            index = Math.min(index, maxIndex);
            applyTrackOffset(getBaseOffset());
            if (progress && slides.length > 1) {
                var progressEnd = Math.min(slides.length, index + visible);
                progress.style.width = (progressEnd / slides.length) * 100 + "%";
            }
            if (nav)
                nav.style.display = '';
            if (prev)
                prev.disabled = index <= 0;
            if (next)
                next.disabled = index >= maxIndex;
        }
        else {
            index = 0;
            track.style.transform = '';
            if (nav)
                nav.style.display = 'none';
        }
        equalizeCardHeaders(panel);
    }
    function goTo(newIndex) {
        if (!isCarouselMode())
            return;
        var maxIndex = getCarouselMetrics().maxIndex;
        index = Math.max(0, Math.min(maxIndex, newIndex));
        update();
    }
    prev === null || prev === void 0 ? void 0 : prev.addEventListener('click', function () { return goTo(index - 1); });
    next === null || next === void 0 ? void 0 : next.addEventListener('click', function () { return goTo(index + 1); });
    window.addEventListener('resize', update);
    carousel_swipe_1.initCarouselSwipe({
        viewport: viewport,
        isEnabled: isCarouselMode,
        getBaseOffset: getBaseOffset,
        onDrag: applyTrackOffset,
        onCommit: function (direction) {
            if (!isCarouselMode())
                return;
            if (direction === 0) {
                update();
                return;
            }
            goTo(index + direction);
        },
    });
    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(function () { return equalizeCardHeaders(panel); });
        resizeObserver.observe(track);
    }
    slides.forEach(function (slide) {
        slide.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
                img.addEventListener('load', function () { return equalizeCardHeaders(panel); }, { once: true });
            }
        });
    });
    update();
}
},{"../../utils/carousel-swipe":14,"../../utils/equalize-heights":16}],8:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSegmentedToggle = void 0;
var ROOT_SELECTOR = '[data-segmented-toggle-root]';
var TOGGLE_SELECTOR = '[data-segmented-toggle]';
var TAB_SELECTOR = '[data-segmented-toggle-tab]';
var THUMB_SELECTOR = '[data-segmented-toggle-thumb]';
var PANEL_SELECTOR = '[data-segmented-toggle-panel]';
function initSegmentedToggle() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSegmentedToggleRoot);
    document.querySelectorAll(TOGGLE_SELECTOR).forEach(function (toggle) {
        if (!toggle.closest(ROOT_SELECTOR)) {
            initSegmentedToggleControl(toggle);
        }
    });
}
exports.initSegmentedToggle = initSegmentedToggle;
function initSegmentedToggleRoot(root) {
    var toggle = root.querySelector(TOGGLE_SELECTOR);
    if (!toggle)
        return;
    initSegmentedToggleControl(toggle, root);
}
function initSegmentedToggleControl(toggle, root) {
    var _a, _b;
    var tabs = toggle.querySelectorAll(TAB_SELECTOR);
    var thumb = toggle.querySelector(THUMB_SELECTOR);
    var panelRoot = root !== null && root !== void 0 ? root : toggle.closest(ROOT_SELECTOR);
    var panels = (_a = panelRoot === null || panelRoot === void 0 ? void 0 : panelRoot.querySelectorAll(PANEL_SELECTOR)) !== null && _a !== void 0 ? _a : [];
    if (!tabs.length || !thumb)
        return;
    var activate = function (activeTab) {
        var id = activeTab.getAttribute('data-segmented-toggle-tab');
        tabs.forEach(function (tab) {
            var isActive = tab === activeTab;
            tab.classList.toggle('segmented-toggle__btn--active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        updateThumb(toggle, thumb, activeTab);
        if (!id || !panels.length)
            return;
        panels.forEach(function (panel) {
            var isActive = panel.getAttribute('data-segmented-toggle-panel') === id;
            panel.classList.toggle('segmented-toggle-panel--hidden', !isActive);
        });
    };
    var initialTab = (_b = toggle.querySelector(TAB_SELECTOR + ".segmented-toggle__btn--active")) !== null && _b !== void 0 ? _b : tabs[0];
    activate(initialTab);
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { return activate(tab); });
    });
    var updateActiveThumb = function () {
        var current = toggle.querySelector(TAB_SELECTOR + ".segmented-toggle__btn--active");
        if (current)
            updateThumb(toggle, thumb, current);
    };
    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(updateActiveThumb);
        resizeObserver.observe(toggle);
    }
    window.addEventListener('resize', updateActiveThumb);
}
function updateThumb(toggle, thumb, activeTab) {
    thumb.style.width = activeTab.offsetWidth + "px";
    thumb.style.transform = "translateX(" + activeTab.offsetLeft + "px)";
}
},{}],9:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTopicSelector = void 0;
var ROOT_SELECTOR = '[data-topic-selector]';
var DESKTOP_SELECTOR = '[data-topic-selector-desktop]';
var TAB_SELECTOR = '[data-topic-selector-tab]';
var PANEL_SELECTOR = '[data-topic-selector-panel]';
function initTopicSelector() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initTopicSelectorRoot);
}
exports.initTopicSelector = initTopicSelector;
function initTopicSelectorRoot(root) {
    var desktop = root.querySelector(DESKTOP_SELECTOR);
    if (!desktop)
        return;
    var tabs = desktop.querySelectorAll(TAB_SELECTOR);
    var panels = desktop.querySelectorAll(PANEL_SELECTOR);
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            var id = tab.getAttribute('data-topic-selector-tab');
            if (!id)
                return;
            tabs.forEach(function (item) {
                var isActive = item === tab;
                item.classList.toggle('topic-selector__tab--active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            panels.forEach(function (panel) {
                var isActive = panel.getAttribute('data-topic-selector-panel') === id;
                panel.classList.toggle('topic-selector__panel--hidden', !isActive);
            });
        });
    });
}
},{}],10:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTrustpilotBanner = void 0;
function initTrustpilotBanner() {
    var widgets = document.querySelectorAll('.trustpilot-banner .trustpilot-widget');
    if (!widgets.length) {
        return;
    }
    var loadWidgets = function () {
        var _a;
        if (!((_a = window.Trustpilot) === null || _a === void 0 ? void 0 : _a.loadFromElement)) {
            return false;
        }
        widgets.forEach(function (widget) {
            var _a;
            (_a = window.Trustpilot) === null || _a === void 0 ? void 0 : _a.loadFromElement(widget, true);
        });
        return true;
    };
    if (loadWidgets()) {
        return;
    }
    var intervalId = window.setInterval(function () {
        if (loadWidgets()) {
            window.clearInterval(intervalId);
        }
    }, 100);
    window.setTimeout(function () { return window.clearInterval(intervalId); }, 10000);
}
exports.initTrustpilotBanner = initTrustpilotBanner;
},{}],11:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSearchResults = void 0;
var axios_1 = __importDefault(require("axios"));
var ROOT_SELECTOR = '.search-results-page';
function initSearchResults() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSearchResultsRoot);
}
exports.initSearchResults = initSearchResults;
function initSearchResultsRoot(searchResultsPage) {
    var _this = this;
    var isLoading = false;
    var ITEMS_PER_PAGE = 10;
    var searchResultsContainer = searchResultsPage.querySelector('.questions-list__items');
    var searchResultsTitle = searchResultsPage.querySelector('.header-with-search__title-single');
    var searchResultsCountNumber = searchResultsPage.querySelector('.header-with-search__count-number');
    var loadMoreBtn = searchResultsPage.querySelector('.questions-list__load-more');
    var query = (searchResultsPage === null || searchResultsPage === void 0 ? void 0 : searchResultsPage.getAttribute('data-query')) || '';
    var hasMore = (searchResultsPage === null || searchResultsPage === void 0 ? void 0 : searchResultsPage.getAttribute('data-has-more')) === 'True' || false;
    var currentPage = parseInt((searchResultsPage === null || searchResultsPage === void 0 ? void 0 : searchResultsPage.getAttribute('data-next-page')) || '1', 10);
    var fetchSearchFaqArticlesResults = function (page) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        query: query,
                        pageNumber: page,
                        pageSize: ITEMS_PER_PAGE,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post('/api/articles/search', payload)];
                case 2:
                    response = _a.sent();
                    return [2, response.data];
                case 3:
                    error_1 = _a.sent();
                    throw error_1;
                case 4: return [2];
            }
        });
    }); };
    var renderArticle = function (_a) {
        var title = _a.title, url = _a.url;
        var absoluteLink = new URL(url.replace('~', ''), window.location.origin).toString();
        return ("\n            <li class=\"questions-list__item\">\n                <a class=\"questions-list__card\" href=\"" + absoluteLink + "\">\n                    <span class=\"questions-list__text\">" + title + "</span>\n                    <img class=\"questions-list__chevron\" src=\"/assets/img/arrow-right.svg\" alt=\"\" aria-hidden=\"true\" />\n                </a>\n            </li>\n        ").trim();
    };
    var appendArticles = function (articles) {
        if (!searchResultsContainer)
            return;
        var fragment = document.createDocumentFragment();
        var temp = document.createElement('ul');
        temp.innerHTML = articles.map(renderArticle).join('');
        while (temp.firstChild) {
            fragment.appendChild(temp.firstChild);
        }
        searchResultsContainer.appendChild(fragment);
    };
    function setLoadMoreVisibility(visible) {
        if (!loadMoreBtn)
            return;
        if (visible) {
            loadMoreBtn.classList.remove('hidden');
        }
        else {
            loadMoreBtn.classList.add('hidden');
        }
    }
    var setLoadingState = function (loading) {
        if (!loadMoreBtn)
            return;
        isLoading = loading;
        loadMoreBtn.disabled = loading;
        loadMoreBtn.textContent = loading ? 'Loading...' : 'Load more';
    };
    var loadMore = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading || !hasMore)
                        return [2];
                    setLoadingState(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, fetchSearchFaqArticlesResults(currentPage)];
                case 2:
                    response = _a.sent();
                    appendArticles(response.items);
                    hasMore = response.hasMore;
                    currentPage = response.nextPage;
                    searchResultsCountNumber.innerHTML = response.count.toString();
                    searchResultsTitle.innerHTML = query;
                    setLoadMoreVisibility(hasMore);
                    return [3, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Failed to fetch help topics:', error_2);
                    return [3, 5];
                case 4:
                    setLoadingState(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.addEventListener('click', function () { return loadMore(); });
}
},{"axios":18}],12:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSubTopics = void 0;
var axios_1 = __importDefault(require("axios"));
var ROOT_SELECTOR = '.subtopics';
function initSubTopics() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSubTopicsRoot);
}
exports.initSubTopics = initSubTopics;
function initSubTopicsRoot(subtopics) {
    var _this = this;
    var isLoading = false;
    var topic = '';
    var articlesContainer = subtopics.querySelector('.questions-list__items');
    var loadMoreBtn = subtopics.querySelector('.questions-list__load-more');
    var fetchFaqArticles = function () { return __awaiter(_this, void 0, void 0, function () {
        var pathParts, pageName, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pathParts = window.location.pathname.split('/');
                    pageName = document.documentElement.dataset.pageName || '';
                    topic = pageName || pathParts[pathParts.length - 1].replaceAll('-', ' ') || '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.get("/api/articles?topic=" + encodeURIComponent(topic))];
                case 2:
                    response = _a.sent();
                    return [2, response.data];
                case 3:
                    error_1 = _a.sent();
                    throw error_1;
                case 4: return [2];
            }
        });
    }); };
    var renderArticle = function (_a) {
        var title = _a.title, url = _a.url;
        var absoluteLink = new URL(url.replace('~', ''), window.location.origin).toString();
        return ("\n            <li class=\"questions-list__item\">\n                <a class=\"questions-list__card\" href=\"" + absoluteLink + "\">\n                    <span class=\"questions-list__text\">" + title + "</span>\n                    <img class=\"questions-list__chevron\" src=\"/assets/img/arrow-right.svg\" alt=\"\" aria-hidden=\"true\" />\n                </a>\n            </li>\n        ").trim();
    };
    var appendArticles = function (articles) {
        if (!articlesContainer)
            return;
        var fragment = document.createDocumentFragment();
        var temp = document.createElement('ul');
        temp.innerHTML = articles.map(renderArticle).join('');
        while (temp.firstChild) {
            fragment.appendChild(temp.firstChild);
        }
        articlesContainer.appendChild(fragment);
    };
    var setLoadingState = function (loading) {
        if (!loadMoreBtn)
            return;
        isLoading = loading;
        loadMoreBtn.disabled = loading;
        loadMoreBtn.textContent = loading ? 'Loading...' : 'Load more';
    };
    var loadArticles = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2];
                    setLoadingState(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, fetchFaqArticles()];
                case 2:
                    response = _a.sent();
                    appendArticles(response);
                    return [3, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Failed to fetch help topics:', error_2);
                    return [3, 5];
                case 4:
                    setLoadingState(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    loadArticles();
}
},{"axios":18}],13:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initArticleSearchAutocomplete = void 0;
var debounce_1 = require("./debounce");
var suggestions_scrollbar_1 = require("./suggestions-scrollbar");
var DEFAULT_API_URL = '/api/articles/search';
var DEFAULT_DEBOUNCE_MS = 300;
var DEFAULT_MIN_QUERY_LENGTH = 1;
var DEFAULT_MAX_SUGGESTIONS = 8;
function resolveArticleUrl(url) {
    var path = url.replace(/^~\/?/, '/');
    return new URL(path, window.location.origin).toString();
}
function normalizeSuggestion(item) {
    var _a, _b;
    if (!item || typeof item !== 'object')
        return null;
    var record = item;
    var title = (_a = record.title) !== null && _a !== void 0 ? _a : record.Title;
    var url = (_b = record.url) !== null && _b !== void 0 ? _b : record.Url;
    if (typeof title !== 'string' || typeof url !== 'string' || !title || !url) {
        return null;
    }
    return { title: title, url: url };
}
function normalizeSuggestions(data) {
    if (!Array.isArray(data))
        return [];
    return data
        .map(normalizeSuggestion)
        .filter(function (item) { return item !== null; });
}
function getMockSuggestions(root) {
    if (root.dataset.searchUseMock !== 'true')
        return null;
    var dataElement = root.querySelector('script[data-search-mock-suggestions]');
    if (!(dataElement === null || dataElement === void 0 ? void 0 : dataElement.textContent))
        return [];
    try {
        return normalizeSuggestions(JSON.parse(dataElement.textContent));
    }
    catch (_a) {
        return [];
    }
}
function filterSuggestionsByQuery(items, query) {
    var normalizedQuery = query.toLowerCase();
    return items.filter(function (item) { return item.title.toLowerCase().includes(normalizedQuery); });
}
function initArticleSearchAutocomplete(_a) {
    var root = _a.root, input = _a.input, suggestionsList = _a.suggestionsList, _b = _a.apiUrl, apiUrl = _b === void 0 ? root.dataset.searchApiUrl || DEFAULT_API_URL : _b, _c = _a.debounceMs, debounceMs = _c === void 0 ? DEFAULT_DEBOUNCE_MS : _c, _d = _a.minQueryLength, minQueryLength = _d === void 0 ? DEFAULT_MIN_QUERY_LENGTH : _d, _e = _a.maxSuggestions, maxSuggestions = _e === void 0 ? DEFAULT_MAX_SUGGESTIONS : _e;
    var suggestionsPanel = suggestionsList.closest('.header-with-search__suggestions-panel');
    var mockSuggestions = getMockSuggestions(root);
    var keepSuggestionsOpen = root.dataset.searchKeepOpen === 'true';
    var activeIndex = -1;
    var abortController = null;
    var closeTimeout = 0;
    var suggestions = [];
    var suggestionId = suggestionsList.id || "search-suggestions-" + Math.random().toString(36).slice(2, 9);
    suggestionsList.id = suggestionId;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', suggestionId);
    input.setAttribute('aria-expanded', 'false');
    function setExpanded(isOpen) {
        input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    function setSuggestionsPanelVisible(isVisible) {
        if (suggestionsPanel) {
            suggestionsPanel.hidden = !isVisible;
            return;
        }
        suggestionsList.hidden = !isVisible;
    }
    function hideSuggestions() {
        if (keepSuggestionsOpen)
            return;
        suggestions = [];
        activeIndex = -1;
        suggestionsList.innerHTML = '';
        setSuggestionsPanelVisible(false);
        setExpanded(false);
        input.removeAttribute('aria-activedescendant');
    }
    function renderSuggestions(items) {
        suggestions = items.slice(0, maxSuggestions);
        activeIndex = -1;
        suggestionsList.innerHTML = '';
        if (!suggestions.length) {
            hideSuggestions();
            return;
        }
        suggestions.forEach(function (item, index) {
            var li = document.createElement('li');
            li.className = 'header-with-search__suggestion';
            li.setAttribute('role', 'option');
            li.id = suggestionId + "-option-" + index;
            var link = document.createElement('a');
            link.className = 'header-with-search__suggestion-link';
            link.href = resolveArticleUrl(item.url);
            link.textContent = item.title;
            li.appendChild(link);
            suggestionsList.appendChild(li);
        });
        setSuggestionsPanelVisible(true);
        setExpanded(true);
        if (suggestionsPanel) {
            suggestions_scrollbar_1.initSuggestionsScrollbar(suggestionsPanel);
            window.requestAnimationFrame(function () { return suggestions_scrollbar_1.updateSuggestionsScrollbar(suggestionsPanel); });
        }
    }
    function highlightSuggestion(index) {
        var options = suggestionsList.querySelectorAll('[role="option"]');
        options.forEach(function (option, optionIndex) {
            var isActive = optionIndex === index;
            option.classList.toggle('header-with-search__suggestion--active', isActive);
            if (isActive) {
                input.setAttribute('aria-activedescendant', option.id);
            }
        });
        if (index < 0) {
            input.removeAttribute('aria-activedescendant');
        }
    }
    function fetchSuggestions(query) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (mockSuggestions) {
                            renderSuggestions(filterSuggestionsByQuery(mockSuggestions, query));
                            return [2];
                        }
                        abortController === null || abortController === void 0 ? void 0 : abortController.abort();
                        abortController = new AbortController();
                        url = new URL(apiUrl, window.location.origin);
                        url.searchParams.set('q', query);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, fetch(url.toString(), { signal: abortController.signal })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            hideSuggestions();
                            return [2];
                        }
                        return [4, response.json()];
                    case 3:
                        data = _a.sent();
                        renderSuggestions(normalizeSuggestions(data));
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        if (error_1.name !== 'AbortError') {
                            hideSuggestions();
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    }
    var debouncedFetch = debounce_1.debounce(function (query) {
        void fetchSuggestions(query);
    }, debounceMs);
    function handleInput() {
        var query = input.value.trim();
        if (query.length < minQueryLength) {
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
            if (keepSuggestionsOpen && mockSuggestions) {
                renderSuggestions(mockSuggestions);
                return;
            }
            hideSuggestions();
            return;
        }
        debouncedFetch(query);
    }
    function openActiveSuggestion() {
        if (activeIndex < 0 || !suggestions[activeIndex])
            return;
        window.location.href = resolveArticleUrl(suggestions[activeIndex].url);
    }
    input.addEventListener('input', handleInput);
    input.addEventListener('keydown', function (event) {
        if (!suggestions.length)
            return;
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            activeIndex = Math.min(activeIndex + 1, suggestions.length - 1);
            highlightSuggestion(activeIndex);
            return;
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            activeIndex = Math.max(activeIndex - 1, 0);
            highlightSuggestion(activeIndex);
            return;
        }
        if (event.key === 'Enter' && activeIndex >= 0) {
            event.preventDefault();
            openActiveSuggestion();
            return;
        }
        if (event.key === 'Escape' && !keepSuggestionsOpen) {
            hideSuggestions();
        }
    });
    if (!keepSuggestionsOpen) {
        input.addEventListener('blur', function () {
            window.clearTimeout(closeTimeout);
            closeTimeout = window.setTimeout(function () { return hideSuggestions(); }, 150);
        });
        root.addEventListener('focusout', function (event) {
            var nextTarget = event.relatedTarget;
            if (nextTarget && root.contains(nextTarget))
                return;
            hideSuggestions();
        });
    }
    suggestionsList.addEventListener('mousedown', function (event) {
        event.preventDefault();
    });
    if (keepSuggestionsOpen && mockSuggestions) {
        var query = input.value.trim();
        renderSuggestions(query ? filterSuggestionsByQuery(mockSuggestions, query) : mockSuggestions);
    }
}
exports.initArticleSearchAutocomplete = initArticleSearchAutocomplete;
},{"./debounce":15,"./suggestions-scrollbar":17}],14:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCarouselSwipe = void 0;
var SWIPE_THRESHOLD = 48;
var DIRECTION_LOCK_THRESHOLD = 8;
var INTERACTIVE_SELECTOR = 'button, a, input, textarea, select, label, summary, [role="button"]';
function isInteractiveTarget(target) {
    return target instanceof Element && Boolean(target.closest(INTERACTIVE_SELECTOR));
}
function initCarouselSwipe(_a) {
    var viewport = _a.viewport, _b = _a.isEnabled, isEnabled = _b === void 0 ? function () { return true; } : _b, getBaseOffset = _a.getBaseOffset, onDrag = _a.onDrag, onCommit = _a.onCommit;
    var startX = 0;
    var startY = 0;
    var baseOffset = 0;
    var isDragging = false;
    var directionLocked = null;
    var capturedPointerId = null;
    viewport.style.touchAction = 'pan-y pinch-zoom';
    function releaseCapture() {
        if (capturedPointerId !== null && viewport.hasPointerCapture(capturedPointerId)) {
            viewport.releasePointerCapture(capturedPointerId);
        }
        capturedPointerId = null;
    }
    function resetGesture() {
        isDragging = false;
        directionLocked = null;
        releaseCapture();
    }
    viewport.addEventListener('pointerdown', function (event) {
        if (!isEnabled() || event.button !== 0 || isInteractiveTarget(event.target))
            return;
        isDragging = true;
        directionLocked = null;
        startX = event.clientX;
        startY = event.clientY;
        baseOffset = getBaseOffset();
        viewport.setPointerCapture(event.pointerId);
        capturedPointerId = event.pointerId;
    }, { passive: true });
    viewport.addEventListener('pointermove', function (event) {
        if (!isDragging)
            return;
        var deltaX = startX - event.clientX;
        var deltaY = startY - event.clientY;
        if (!directionLocked) {
            if (Math.abs(deltaX) < DIRECTION_LOCK_THRESHOLD && Math.abs(deltaY) < DIRECTION_LOCK_THRESHOLD) {
                return;
            }
            directionLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
            if (directionLocked === 'vertical') {
                resetGesture();
                return;
            }
        }
        if (directionLocked !== 'horizontal')
            return;
        event.preventDefault();
        onDrag(Math.max(0, baseOffset + deltaX));
    }, { passive: false });
    var end = function (event) {
        if (!isDragging)
            return;
        var lockedDirection = directionLocked;
        resetGesture();
        if (!isEnabled()) {
            onCommit(0);
            return;
        }
        if (lockedDirection === 'vertical') {
            onCommit(0);
            return;
        }
        var deltaX = startX - event.clientX;
        var deltaY = startY - event.clientY;
        var absDeltaX = Math.abs(deltaX);
        var absDeltaY = Math.abs(deltaY);
        var isHorizontalSwipe = lockedDirection === 'horizontal' ||
            (lockedDirection === null && absDeltaX >= SWIPE_THRESHOLD && absDeltaX > absDeltaY);
        if (isHorizontalSwipe && absDeltaX >= SWIPE_THRESHOLD) {
            onCommit(deltaX > 0 ? 1 : -1);
            return;
        }
        onCommit(0);
    };
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('lostpointercapture', resetGesture);
}
exports.initCarouselSwipe = initCarouselSwipe;
},{}],15:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
function debounce(fn, delayMs) {
    var timeoutId = 0;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function () { return fn.apply(void 0, args); }, delayMs);
    };
}
exports.debounce = debounce;
},{}],16:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalizeHeights = void 0;
function equalizeHeights(elements) {
    var items = Array.from(elements);
    items.forEach(function (element) {
        element.style.minHeight = '';
    });
    if (items.length < 2)
        return;
    var maxHeight = 0;
    items.forEach(function (element) {
        maxHeight = Math.max(maxHeight, element.getBoundingClientRect().height);
    });
    items.forEach(function (element) {
        element.style.minHeight = maxHeight + "px";
    });
}
exports.equalizeHeights = equalizeHeights;
},{}],17:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAllSuggestionsScrollbars = exports.initSuggestionsScrollbar = exports.updateSuggestionsScrollbar = void 0;
var PANEL_SELECTOR = '.header-with-search__suggestions-panel';
var SCROLLABLE_SELECTOR = '.header-with-search__suggestions';
var TRACK_SELECTOR = '.header-with-search__suggestions-scrollbar';
var THUMB_SELECTOR = '.header-with-search__suggestions-scrollbar-thumb';
var HIDDEN_CLASS = 'header-with-search__suggestions-scrollbar--hidden';
var MIN_THUMB_HEIGHT = 32;
function getScrollbarElements(panel) {
    var scrollable = panel.querySelector(SCROLLABLE_SELECTOR);
    var track = panel.querySelector(TRACK_SELECTOR);
    var thumb = panel.querySelector(THUMB_SELECTOR);
    if (!scrollable || !track || !thumb)
        return null;
    return { scrollable: scrollable, track: track, thumb: thumb };
}
function updateSuggestionsScrollbar(panel) {
    var elements = getScrollbarElements(panel);
    if (!elements)
        return;
    var scrollable = elements.scrollable, track = elements.track, thumb = elements.thumb;
    var scrollHeight = scrollable.scrollHeight, clientHeight = scrollable.clientHeight, scrollTop = scrollable.scrollTop;
    var hasOverflow = scrollHeight > clientHeight + 1;
    track.classList.toggle(HIDDEN_CLASS, !hasOverflow);
    if (!hasOverflow) {
        thumb.style.height = '';
        thumb.style.transform = '';
        return;
    }
    var trackHeight = track.clientHeight;
    var thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, MIN_THUMB_HEIGHT);
    var maxThumbOffset = trackHeight - thumbHeight;
    var scrollableDistance = scrollHeight - clientHeight;
    var thumbOffset = scrollableDistance > 0 ? (scrollTop / scrollableDistance) * maxThumbOffset : 0;
    thumb.style.height = thumbHeight + "px";
    thumb.style.transform = "translateY(" + thumbOffset + "px)";
}
exports.updateSuggestionsScrollbar = updateSuggestionsScrollbar;
function initSuggestionsScrollbar(panel) {
    var elements = getScrollbarElements(panel);
    if (!elements)
        return;
    var scrollable = elements.scrollable;
    if (panel.dataset.suggestionsScrollbarInit === 'true') {
        updateSuggestionsScrollbar(panel);
        return;
    }
    panel.dataset.suggestionsScrollbarInit = 'true';
    scrollable.addEventListener('scroll', function () { return updateSuggestionsScrollbar(panel); }, { passive: true });
    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(function () { return updateSuggestionsScrollbar(panel); });
        resizeObserver.observe(scrollable);
        resizeObserver.observe(panel);
    }
    updateSuggestionsScrollbar(panel);
}
exports.initSuggestionsScrollbar = initSuggestionsScrollbar;
function initAllSuggestionsScrollbars(root) {
    if (root === void 0) { root = document; }
    root.querySelectorAll(PANEL_SELECTOR).forEach(initSuggestionsScrollbar);
}
exports.initAllSuggestionsScrollbars = initAllSuggestionsScrollbars;
},{}],18:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":20}],19:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":26,"../core/createError":27,"./../core/settle":31,"./../helpers/buildURL":35,"./../helpers/cookies":37,"./../helpers/isURLSameOrigin":40,"./../helpers/parseHeaders":42,"./../utils":45}],20:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":21,"./cancel/CancelToken":22,"./cancel/isCancel":23,"./core/Axios":24,"./core/mergeConfig":30,"./defaults":33,"./helpers/bind":34,"./helpers/isAxiosError":39,"./helpers/spread":43,"./utils":45}],21:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],22:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":21}],23:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],24:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":35,"../helpers/validator":44,"./../utils":45,"./InterceptorManager":25,"./dispatchRequest":28,"./mergeConfig":30}],25:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":45}],26:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":36,"../helpers/isAbsoluteURL":38}],27:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":29}],28:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":23,"../defaults":33,"./../utils":45,"./transformData":32}],29:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],30:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":45}],31:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":27}],32:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":33,"./../utils":45}],33:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))

},{"./adapters/http":19,"./adapters/xhr":19,"./core/enhanceError":29,"./helpers/normalizeHeaderName":41,"./utils":45,"_process":47}],34:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],35:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":45}],36:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],37:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":45}],38:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],39:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],40:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":45}],41:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":45}],42:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":45}],43:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],44:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":46}],45:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":34}],46:[function(require,module,exports){
module.exports={
  "name": "axios",
  "version": "0.21.4",
  "description": "Promise based HTTP client for the browser and node.js",
  "main": "index.js",
  "scripts": {
    "test": "grunt test",
    "start": "node ./sandbox/server.js",
    "build": "NODE_ENV=production grunt build",
    "preversion": "npm test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    "postversion": "git push && git push --tags",
    "examples": "node ./examples/server.js",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "fix": "eslint --fix lib/**/*.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/axios/axios.git"
  },
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "author": "Matt Zabriskie",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "homepage": "https://axios-http.com",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "jsdelivr": "dist/axios.min.js",
  "unpkg": "dist/axios.min.js",
  "typings": "./index.d.ts",
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ]
}

},{}],47:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],48:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var card_grid_1 = require("../../library/components/card-grid/card-grid");
var header_1 = require("../../library/components/header/header");
var product_tiers_1 = require("../../library/components/product-tiers/product-tiers");
var carousel_1 = require("../../library/components/carousel/carousel");
var topic_selector_1 = require("../../library/components/topic-selector/topic-selector");
var assistance_component_1 = require("../../library/components/assistance-component/assistance-component");
var header_with_search_1 = require("../../library/components/header-with-search/header-with-search");
var subtopics_1 = require("../../library/pages/subtopics");
var trustpilot_banner_1 = require("../../library/components/trustpilot-banner/trustpilot-banner");
var segmented_toggle_1 = require("../../library/components/segmented-toggle/segmented-toggle");
var search_results_1 = require("../../library/pages/search-results");
var article_feedback_1 = require("../../library/components/article-feedback/article-feedback");
function init() {
    header_1.initSiteHeader();
    card_grid_1.initCardGrid();
    product_tiers_1.initProductTiers();
    carousel_1.initCarousel();
    topic_selector_1.initTopicSelector();
    assistance_component_1.initAssistanceComponent();
    header_with_search_1.initHeaderWithSearch();
    subtopics_1.initSubTopics();
    trustpilot_banner_1.initTrustpilotBanner();
    segmented_toggle_1.initSegmentedToggle();
    search_results_1.initSearchResults();
    article_feedback_1.initArticleFeedback();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
}
else {
    init();
}
},{"../../library/components/article-feedback/article-feedback":1,"../../library/components/assistance-component/assistance-component":2,"../../library/components/card-grid/card-grid":3,"../../library/components/carousel/carousel":4,"../../library/components/header-with-search/header-with-search":5,"../../library/components/header/header":6,"../../library/components/product-tiers/product-tiers":7,"../../library/components/segmented-toggle/segmented-toggle":8,"../../library/components/topic-selector/topic-selector":9,"../../library/components/trustpilot-banner/trustpilot-banner":10,"../../library/pages/search-results":11,"../../library/pages/subtopics":12}]},{},[48])(48)
});

